import React from 'react';
import classNames from 'classnames';

import { useIntl } from '../../util/reactIntl';

import css from './CollapsedPanelHandle.module.css';

const TownHallIcon = () => (
  <svg className={css.icon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8.1a2.5 2.5 0 0 1-1.5 2.3L12 19.5l-6.5-3.6A2.5 2.5 0 0 1 4 13.6V5.5Zm2.5-.5a.5.5 0 0 0-.5.5v8.1c0 .16.08.31.21.4L12 17.4l5.79-3.4c.13-.09.21-.24.21-.4V5.5a.5.5 0 0 0-.5-.5h-11ZM8 8h8v1.5H8V8Zm0 3.25h5.5V12.8H8v-1.55Z"
    />
  </svg>
);

const AssetMarketIcon = () => (
  <svg className={css.icon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v11A2.5 2.5 0 0 1 17.5 20h-11A2.5 2.5 0 0 1 4 17.5v-11ZM6.5 5.5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1h-11ZM8 8h3v3H8V8Zm5 0h3v3h-3V8ZM8 13h3v3H8v-3Zm5 0h3v3h-3v-3Z"
    />
  </svg>
);

const PANEL_META = {
  townhall: {
    Icon: TownHallIcon,
    tooltipId: 'DualPaneLayout.collapsedTownHallTooltip',
    labelId: 'DualPaneLayout.collapsedTownHallLabel',
  },
  market: {
    Icon: AssetMarketIcon,
    tooltipId: 'DualPaneLayout.collapsedMarketTooltip',
    labelId: 'DualPaneLayout.collapsedMarketLabel',
  },
};

const CollapsedPanelHandle = props => {
  const { panelKey, edge, isHorizontal, onRestore } = props;
  const intl = useIntl();
  const meta = PANEL_META[panelKey];

  if (!meta) {
    return null;
  }

  const { Icon } = meta;
  const tooltip = intl.formatMessage({ id: meta.tooltipId });
  const label = intl.formatMessage({ id: meta.labelId });

  return (
    <button
      type="button"
      className={classNames(css.handle, {
        [css.handleTownHall]: panelKey === 'townhall',
        [css.handleMarket]: panelKey === 'market',
        [css.handleHorizontal]: isHorizontal,
        [css.handleVertical]: !isHorizontal,
        [css.handleStart]: edge === 'start',
        [css.handleEnd]: edge === 'end',
      })}
      onClick={onRestore}
      aria-label={tooltip}
      title={tooltip}
    >
      <Icon />
      <span className={css.shortLabel}>{label}</span>
      <span className={css.tooltip} role="tooltip">
        {tooltip}
      </span>
    </button>
  );
};

export default CollapsedPanelHandle;
